import backendUrls from '../config/backendUrls.js';

const api = {
  API_BASE: backendUrls.API_BASE
};

export default api;